module.exports = __webpack_public_path__ + "images/erp-nation-glad-bottom.1782880901430.png";